import styled from '@emotion/styled/macro';
import {
    BaseButton,
    BaseImage,
    forPhoneOnly,
    forTabletLandscapeDown,
    forTabletPortraitDown,
    TopNav,
    TopNavItem,
    TopNavLeft,
    TopNavRight,
    Variables,
} from '@enter/core';
import Icon from '@mdi/react';

export const Logo = styled(BaseImage)`
    height: 30px;
    width: auto;
`;

export const LogoSection = styled.div`
    padding: 0 24px;
    display: flex;
    align-items: center;
    border-right: 1px solid #DAE0E7;
    width: ${Variables.sidebarSize};
    height: ${Variables.topnavSize};
    justify-content: space-between;
`;

export const DesktopItem = styled(TopNavItem)`
    display: inline-flex;
    ${forTabletLandscapeDown(`
        display: none;
    `)};
`;
export const MobileItem = styled(TopNavItem)`
    display: none;
    ${forTabletLandscapeDown(`
        display: inline-flex;
    `)};
`;

export const MainNav = styled(TopNav)`
    display: flex;
    width: 100%;
    border-bottom: none;
    /* margin-left: ${Variables.sidebarSize}; */
    overflow: hidden;
    z-index: 1201;

    /* ${TopNavLeft} ${TopNavItem} {
        flex-grow: 1;
    } */
    ${TopNavRight} > ${MobileItem},
    ${TopNavLeft} > ${MobileItem} {
        display: none;
    }

    position: fixed;
    background-color: ${Variables.Colors.sidebarBackground};
    
    ${TopNavLeft} {
        margin-left: 0;
    }


    /* position: absolute;
    display: flex;
    width: 100%;
    z-index: 25;
    /* border-bottom: none; */
    /* margin-left: 0; */
    /* padding-left: 80px; */

    ${forTabletLandscapeDown(`
        background-color: ${Variables.Colors.sidebarBackground};

        ${TopNavLeft} {
            margin: 0;
        }
        & > ${TopNavRight} > ${DesktopItem},
        & > ${TopNavLeft} > ${DesktopItem} {
            display: none
        }
        & > ${TopNavRight} > ${MobileItem},
        & > ${TopNavLeft} > ${MobileItem} {
            display: inline-flex;
        }
    `)};
`;

export const LogoSpacer = styled.span`
    display: inline-flex;
    width: 80px;
`;

export const Spacer = styled.span`
    flex-grow: 1;
    display: inline-flex;
`;

export const StyledIcon = styled(Icon)`
    height: 24px;
    width: 24px;
`;

export const SearchBarWrapper = styled.div`
    ${forTabletPortraitDown(`
        display: none;
    `)}
    
    & > div > div {
        background-color: #DAE0E7;
        border-radius: 50px;
        border: none;
        outline: none;
        overflow: hidden;
        width: 320px;
        min-width: 320px;
    }
    
    & input {
        background-color: #DAE0E7;
        border: none;
        outline: none;
    }
    
    & input:focus {
        outline: none;
        box-shadow: none;
    }
`;

export const SidebarPanel = styled.div<{ light: boolean }>`
    min-width: ${Variables.sidebarSize};
    background: ${Variables.Colors.b300};
    display: flex;
    align-items: center;
    height: 100%;
    transition: all 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    border-right: solid 1px ${Variables.Colors.nx8};

    ${({ light }) =>
        light
            ? `
            background: ${Variables.Colors.ghostWhite};
            ${MenuButton} {
                fill: ${Variables.Colors.ghostWhite};
            }

            ${Logo} {
                background-color: none;
            }

            ${forTabletLandscapeDown(`
                background: ${Variables.Colors.b300};
            `)}
    `
            : undefined}
`;

export const MenuButton = styled(BaseButton)`
    display: none;
    display: inline-flex;
    margin: 12px 24px;
    padding: 0 8px;
    min-width: unset;
    cursor: pointer;
    z-index: 100;
    fill: ${Variables.Colors.ghostWhite};

    ${forPhoneOnly(`
        margin: 12px;
    `)};
`;

export const CollapseButton = styled(BaseButton)<{ collapsed?: boolean }>`
    min-width: 32px;
    width: 32px;
    height: 32px;
    padding: 4px;
    background-color: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background-color: ${Variables.Colors.n5};
        border-color: #DAE0E7;
    }

    svg {
        fill: #3E4D64;
    }
`;
